import Home from "@/pages/Home";

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home
  }
];

export default routes.map(route => {
  const meta = {
    public: true,
    onlyLoggedOut: true
  };
  return { ...route, meta };
});
